import { createMachine, assign } from 'xstate';
import { loyaltyCreateRedemptions } from '../requests/loyalty-create-redemptions';
import { PreOrderPayload } from '@fingermarkglobal/types';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;

    if (data) {
      logger.debug(`api - loyaltyCreateRedemptions - FSM data recieved:`, data);
      return data;
    }

    if (error) {
      logger.error(`api - loyaltyCreateRedemptions - FSM error recieved:`, error);
      return error;
    }

    logger.error(`api - loyaltyCreateRedemptions - FSM message recieved:`, message);
    return message;
  },
});

const createLoyaltyCreateRedemptionsMachine = ({
  token = '',
  transactionId = '',
  payload = null,
  promoId = '',
  redemptions = [],
} = {}) =>
  createMachine<{
    token: string;
    transactionId: string;
    payload: any | PreOrderPayload;
    promoId: string;
    redemptions: string[];
  }>(
    {
      id: 'loyaltyCreateRedemptions',
      initial: 'processing',
      context: {
        token,
        transactionId,
        payload,
        promoId,
        redemptions,
      },
      states: {
        processing: {
          invoke: {
            src: ({ token, transactionId, payload, promoId }) =>
              loyaltyCreateRedemptions({ token, transactionId, payload, promoId, redemptions }),
            onDone: {
              target: 'success',
              actions: ['populateMessage'],
            },
            onError: {
              target: 'error',
              actions: ['populateMessage'],
            },
          },
        },
        success: {
          on: {
            IDLE: 'processing',
          },
        },
        error: { type: 'final' },
      },
    },
    {
      actions: {
        populateMessage,
      },
    },
  );

export { createLoyaltyCreateRedemptionsMachine };
